<template>
  <div class="setting-container">
    <div class="setting-box" v-loading="loading">
      <div class="setting">
        <div class="title">A等级：</div>
        <div class="content">
          2项均大于0，记
          <el-input size="mini" type="number" v-model="data.Ascore"/>分
        </div>
      </div>
      <div class="setting">
        <div class="title">B等级：</div>
        <div class="content">
          1项均大于0，记
          <el-input size="mini" type="number" v-model="data.Bscore"/>分
        </div>
      </div>
      <div class="setting">
        <div class="title">C等级：</div>
        <div class="content">
          2项均小于0，记
          <el-input size="mini" type="number" v-model="data.Cscore"/>分
        </div>
      </div>
      <div class="setting">
        <div class="title">D等级：</div>
        <div class="content">
          2项均大于0，且本次均量值不足入口均量值
          <el-input size="mini" type="number" v-model="data.Dratio"/>%，
          记
          <el-input size="mini" type="number" v-model="data.Dscore"/>分
        </div>
      </div>
      <el-button class="setBn" @click="saveSetting" type="primary">保存</el-button>
    </div>
  </div>
</template>
<script>

export default {
  // name: "phonesetting",
  data() {
    return {
      list: [],
      data: {
        ConfigId: 1,
        Ascore: "",
        Bscore: "",
        Cscore: "",
        Dscore: "",
        Dratio: "",
      },
      api: require("@/api/achieve/config").default,
      loading: false,
      isMB: this.$store.state.isMB,
    }
  },
  methods: {
    getData() {
      this.loading = true;
      this.api.info(1).then(res => {
        this.loading = false;
        this.data.Ascore = res.Data.Ascore;
        this.data.Bscore = res.Data.Bscore;
        this.data.Cscore = res.Data.Cscore;
        this.data.Dscore = res.Data.Dscore;
        this.data.Dratio = res.Data.Dratio;
      })
    },
    saveSetting() {
      if(this.data.Ascore%1!=0 || this.data.Ascore === "" || this.data.Ascore < 0) {
        this.$message.error("A等级分数须为不小于0的整数")
        return false
      }
      if(this.data.Bscore%1!=0 || this.data.Bscore === "" || this.data.Bscore < 0) {
        this.$message.error("B等级分数须为不小于0的整数")
        return false
      }
      if(this.data.Cscore%1!=0 || this.data.Cscore === "" || this.data.Cscore < 0) {
        this.$message.error("C等级分数须为不小于0的整数")
        return false
      }
      if(!((this.data.Dratio>0&&this.data.Dratio%1==0)||this.data.Dratio==='0')) {
        this.$message.error("比例值须为不小于0的整数")
        return false
      }
      if(this.data.Dscore%1!=0 || this.data.Dscore === "" || this.data.Dscore < 0) {
        this.$message.error("D等级分数须为不小于0的整数")
        return false
      }
      this.loading = true
      this.api.updateTeacherLv(this.data).then(res => {
        this.loading = false
        if(res.Code==0) {
          this.$message.success("保存成功")
        } else {
          this.$message.error(res.Msg)
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.setting-container{
  padding: 10px 0 0 20px;
  border: 1px solid #eee;
  width: 100%;
  @media screen and (max-width: 767px) {
    padding: 0;
    border: none;
    width: 100%;
  }
}
.setting-box{
  width: 100%;
  height: 300px;
  font-size: 14px;
  position: relative;
  @media screen and (max-width: 767px) {
    border: 1px #ddd solid;
    height: 430px;
    // width: calc(100% - 20px);
  }
  .setting{
    height: 65px;
    display: flex;
    // flex-wrap: wrap;
    align-items: center;
    padding-left: 20px;
    @media screen and (max-width: 767px) {
      height: 90px;
    }
    .title{
      width: 100px;
    }
    .content {
      width: calc(100% - 130px);
      // display: inline-block;
    }
    .mincost{
      width: 220px;
      @media screen and (max-width: 767px){
        width: fit-content
      }
    }
  }
  .h60{
    height: 60px;
    padding-bottom: 20px;
  }
  .el-input{
    width: 70px;
    margin: 0 5px;
    @media screen and (max-width: 767px) {
      width: 57px;
      margin: 0;
    }
    /deep/ .el-input__inner{
      border-top-color: #fff;
      border-left-color: #fff;
      border-right-color: #fff;
      border-bottom-color: #DCDFE6;
      border-radius: 0;
      text-align: center;
      color: #f11;
      font-size: 14px;
    }
  }
  .setBn{
    position: absolute;
    right: 30px;
    bottom: 15px;
    @media screen and (max-width: 767px) {
      right: 20px;
    }
  }
  .schoolselect{
    width: 160px;
    /deep/ .el-input__inner{
      border-top: none;
      border-left: none;
      border-right: none;
      border-radius: 0;
    }
  }
}
</style>